import React from 'react';

import { Home, ReceiptEdit } from 'iconsax-reactjs';
import { useTranslation } from 'react-i18next';

import MenuItem from './components/MenuItem';
import { MenuList } from './styles';

const Menu = React.memo(() => {
  const { t } = useTranslation();

  return (
    <MenuList component="nav">
      <MenuItem icon={<Home />} title={t('sidebar.profile')} link="/" />

      <MenuItem icon={<ReceiptEdit />} title={t('sidebar.mobility_coach')} link="/mobility-coach" />
    </MenuList>
  );
});

export default Menu;
